import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
// const STUDENT = 'student'

const GROUP = 'group'
const GROUP_COURSE = 'group_course'
const ACADEMIC_PERIOD = 'academic_period'
const COURSE_CHAPTER = 'course_chapter'
const GROUP_COURSE_SESSION_PLAN = 'group_course_session_plan'
const START_DATETIME = 'start_datetime'
const START_TIME = 'start_time'
const DURATION_MINUTES = 'duration_minutes'
const LOCATION = 'location'

/**
 * Form model
 */
const formModel = () => {
  return {
    [GROUP]: {
      label: `${t('common.group')}`,
      name: GROUP_COURSE,
    },
    [GROUP_COURSE]: {
      label: `${t('common.group-course')}`,
      name: GROUP_COURSE,
    },
    [ACADEMIC_PERIOD]: {
      label: `${t('school.academic-period')}`,
      name: ACADEMIC_PERIOD,
    },
    [COURSE_CHAPTER]: {
      label: `${t('common.chapter')}`,
      name: COURSE_CHAPTER,
    },
    [GROUP_COURSE_SESSION_PLAN]: {
      label: `${t('common.lesson-plan')}`,
      name: GROUP_COURSE_SESSION_PLAN,
    },
    [START_DATETIME]: {
      label: `${t('common.lesson-start-time')}`,
      name: START_DATETIME,
    },
    [START_TIME]: {
      label: `${t('common.lesson-date')}`,
      name: START_DATETIME,
    },
    [DURATION_MINUTES]: {
      label: `${t('common.duration-minutes')}`,
      name: DURATION_MINUTES,
    },
    [LOCATION]: {
      label: `${t('common.location')}`,
      name: LOCATION,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [GROUP]: null,
  [GROUP_COURSE]: null,
  [ACADEMIC_PERIOD]: null,
  [COURSE_CHAPTER]: null,
  [GROUP_COURSE_SESSION_PLAN]: null,
  [START_DATETIME]: null,
  [DURATION_MINUTES]: '',
  [LOCATION]: '',

}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [GROUP_COURSE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [GROUP_COURSE_SESSION_PLAN]: yup
      .object()
      .nullable(),
    [START_DATETIME]: yup
      .date()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [DURATION_MINUTES]: yup
      .number()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
